import Status from 'clarks/components/ivu-table/status'

let forms = {
   filter_coupons: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         { type: "datepicker", form_type: "daterange", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-md-6 col-lg-5 col-xl-4", validation: "required", placeholder: "Filter Vouchers by Date", model: "date", label: "Date",hide_label: true },
         { type: 'button', btnClass: 'btn-long btn-primary', class: 'col-md-3 col-lg-2', model: 'submit', label: 'Search'}
      ]
   },
}

let tables = {
   coupon: {
      props: {
         icon: 'fa fa-database',
         title: 'Coupon',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['code', 'redemption_code', 'customer_id', 'discount', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Redemption Code", slot: "redemption_code", width: 200, align: 'center'},
            { title: "Customer Id", key: "customer_id", },
            { title: "Discount", slot: "discount", minWidth: 200, align: 'right' },
            { title: "Is Redeemed", slot: "is_redeemed", },
            { title: "Expires At", slot: "valid_until", },
            { title: "Redeemed At", slot: "redeemed_at", },

         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}